class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// Gestione sottomenu: chiudi i fratelli quando ne apri uno
document.addEventListener('DOMContentLoaded', function() {
  const subMenus = document.querySelectorAll('details[id^="Details-HeaderSubMenu-"]');
  
  subMenus.forEach(function(submenu) {
    // Usa 'click' invece di 'toggle' per chiudere PRIMA dell'apertura
    submenu.addEventListener('click', function(e) {
      if (e.target.tagName === 'SUMMARY' || e.target.closest('summary')) {
        // Trova il menu padre
        const parentMenu = this.closest('ul[id^="HeaderMenu-MenuList-"]');
        if (parentMenu && !this.open) {
          // Chiudi tutti gli altri sottomenu fratelli PRIMA che questo si apra
          const siblingSubMenus = parentMenu.querySelectorAll('details[id^="Details-HeaderSubMenu-"]');
          siblingSubMenus.forEach(function(sibling) {
            if (sibling !== submenu && sibling.open) {
              sibling.removeAttribute('open');
            }
          });
        }
      }
    }, true); // Use capture phase
  });
});

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    
    // Aggiungi listener per chiudere PRIMA dell'apertura
    this.mainDetailsToggle.addEventListener('click', (e) => {
      if ((e.target.tagName === 'SUMMARY' || e.target.closest('summary')) && !this.mainDetailsToggle.open) {
        this.closeOtherMenus();
      }
    }, true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  closeOtherMenus() {
    // Trova tutti gli altri header-menu e chiudili
    const allHeaderMenus = document.querySelectorAll('header-menu');
    allHeaderMenus.forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.open) {
        menu.close();
      }
    });

    // Chiudi anche tutti i sottomenu aperti dentro questo menu
    const allSubMenus = this.querySelectorAll('details[id^="Details-HeaderSubMenu-"]');
    allSubMenus.forEach((submenu) => {
      submenu.removeAttribute('open');
    });
  }
}

customElements.define('header-menu', HeaderMenu);
